<span [style.fontSize.px]="size"  >{{value}}</span>
